import { $t } from '@/i18n';
import { CATEGORY } from './const';
import { Modal } from 'ant-design-vue';
import { isEmpty as isObjectEmpty } from 'lodash';
import wujiFetch from '@/utils/wujiFetch';

const draftStorage = {
  get(key) {
    return JSON.parse(localStorage.getItem(key)
      || localStorage.getItem(`${key}}`)  // 兼容逻辑
      || '{}');
  },
  add(key, current) {
    const original = JSON.parse(localStorage.getItem(key) || '{}');
    localStorage.setItem(key, JSON.stringify({
      ...original,
      ...current,
    }));
  },
  remove(key) {
    localStorage.removeItem(key);
    localStorage.removeItem(`${key}}`); // 兼容逻辑
  },
};

const getDraftId = wContext => `${wContext.env}:${wContext.config.id}:${wContext.id}`;

export const DEFAULT_DRAFT_URL = '/api/xy/page/design/draft';

const checkDraftChange = (oData, nData) => {
  if (JSON.stringify(oData) !== JSON.stringify(nData)) {
    return true;
  }
  return false;
};

// 保存远程草稿
const saveDraftDB = async (projectId, key, content) => await wujiFetch(`${DEFAULT_DRAFT_URL}/${projectId}`, {
  method: 'POST',
  body: JSON.stringify({
    key, tenantId: 'wuji',
    content,
  }),
});

// 获取远程草稿
const getDBDraft = async (projectId, key) => {
  const data = await wujiFetch(`${DEFAULT_DRAFT_URL}/${projectId}?key=${key}`);
  if (data.length > 0) {
    const [draft] = data;
    return draft.content;
  }
  return {};
};

// 删除远程草稿
const deleteDBDraft = async (projectId, key) => await wujiFetch(`${DEFAULT_DRAFT_URL}/delete/${projectId}`, {
  method: 'POST',
  body: JSON.stringify({ key }),
});

// 保存草稿
export const saveDraftAtom = {
  id: 'xy:source:saveDraft',
  name: $t('k_29510c35'),
  category: CATEGORY.DRAFT,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'showConfirm',
        type: 'boolean',
        title: $t('k_6c9fc5ff'),
        dafault: false,
      },
      {
        id: 'namespace',
        type: 'string',
        title: $t('k_50dc0493'),
        desc: $t('k_ee418e6d'),
        dafault: '',
      },
    ],
  },
  async execute(ctx, params) {
    const { renderer } = ctx;
    // TODO: isChange为当前上下文是否有编辑过, 需要等ui-core升级才有
    // const { isChanged } = renderer.wContext;
    const { showConfirm, namespace } = params;
    const saveDraft = () => {
      const form = renderer.ucRootForm;
      const data = {};
      form.forEachEditors((editor) => {
        if (editor.value) {
          data[editor.$vnode.key] = editor.value;
        }
        if (editor.array) {
          data[editor.$vnode.key] = editor.array;
        }
      });
      const key = `${getDraftId(renderer.wContext)}${namespace ? `:${namespace}` : ''}`;
      const isChanged = checkDraftChange(draftStorage.get(key), data);
      draftStorage.add(key, data);
      if (isChanged) {
        // 保存至远程DB
        saveDraftDB(renderer.wContext.projectId, key, data);
      }
    };
    if (showConfirm) {
      Modal.confirm({
        content: $t('k_88c23b2'),
        okText: $t('k_82f82611'),
        cancelText: $t('k_83ed1744'),
        onOk: saveDraft,
      });
    } else {
      saveDraft();
    }
  },
};

// 恢复草稿
export const restoreDraftAtom = {
  id: 'xy:source:restoreDraft',
  name: $t('k_202752ab'),
  category: CATEGORY.DRAFT,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'showConfirm',
        type: 'boolean',
        title: $t('k_6c9fc5ff'),
        dafault: true,
      },
      {
        id: 'namespace',
        type: 'string',
        title: $t('k_50dc0493'),
        desc: $t('k_ee418e6d'),
        dafault: '',
      },
      {
        id: 'remainDraftAfterCancel',
        type: 'boolean',
        title: $t('k_afe8015f'),
        default: false,
      },
    ],
  },
  async execute(ctx, params) {
    const { renderer } = ctx;
    const { showConfirm, namespace, remainDraftAfterCancel } = params;
    const key = `${getDraftId(renderer.wContext)}${namespace ? `:${namespace}` : ''}`;
    // 如果本地草稿消失了，应该拿出远程草稿
    const data = !isObjectEmpty(draftStorage.get(key)) ? draftStorage.get(key)
      : (await getDBDraft(renderer.wContext.projectId, key));
    const isEmpty = Object.keys(data).length === 0;

    const restoreDraft = () => {
      const form = renderer.ucRootForm;
      form.forEachEditors((editor) => {
        if (data[editor.$vnode.key]) {
          editor.$emit('change', data[editor.$vnode.key]);
        }
      });
      draftStorage.remove(key);
      deleteDBDraft(renderer.wContext.projectId, key);
    };
    if (!isEmpty && showConfirm) {
      Modal.confirm({
        content: $t('k_53418628'),
        okText: $t('k_e6309c92'),
        cancelText: $t('k_83ed1744'),
        onOk: restoreDraft,
        onCancel: () => {
          if (!remainDraftAfterCancel) {
            draftStorage.remove(key);
            deleteDBDraft(renderer.wContext.projectId, key);
          }
        },
      });
    } else {
      !isEmpty && restoreDraft();
    }
  },
};

// 删除草稿
export const removeDraftAtom = {
  id: 'xy:source:removeDraft',
  name: $t('k_895cadaf'),
  category: CATEGORY.DRAFT,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'namespace',
        type: 'string',
        title: $t('k_50dc0493'),
        desc: $t('k_80a14618'),
        dafault: '',
      },
    ],
  },
  async execute(ctx, params) {
    const { namespace } = params;
    const key = `${getDraftId(ctx.renderer.wContext)}${namespace ? `:${namespace}` : ''}`;
    deleteDBDraft(ctx.renderer.wContext.projectId, key);
    return draftStorage.remove(key);
  },
};

export default [
  saveDraftAtom,
  restoreDraftAtom,
  removeDraftAtom,
];
